module.exports = __webpack_public_path__ + "9fa2aed881cd7f3dea4eb5d773a29bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wbu-giftcard.png
// module id = 249
// module chunks = 0